import styled from 'styled-components'
import logo from './logo.svg'

export default styled.img.attrs({
  src: logo,
  alt: 'PhoneSlate',
})``
